import React from 'react'
import Puzzle from 'react-image-puzzle'
import { useDispatch, useSelector } from 'react-redux'
import { useWindowSize } from 'react-use'
import studygameActions from '../../store/actions/studygameActions'
import GameButtons from './GameButtons'
import NewsGame from './NewsGame'

const PuzzleMinigame = ({ news }) => {
    const dispatch = useDispatch()
    const { width } = useWindowSize()

    const studyGameState = useSelector(state => state.studyGame)
    const { currentRound } = studyGameState
    const newsObject = { ...news, image: true }

    return (
        <article className='white-container mb-4'>
            <NewsGame round={currentRound} news={newsObject} gameTitle='Complete o puzzle da imagem da notícia!' />
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-8 py-8 md:py-10'>
                <div>
                    <img
                        className='object-cover h-full'
                        style={{ filter: 'blur(10px)', msFilter: 'blur(10px)' }}
                        src={news.image}
                        alt={news.title}
                        title={news.title}
                    />
                </div>
                <div className='flex justify-center items-center'>
                    <Puzzle
                        level={3}
                        size={width < 350 ? 200 : 300}
                        image={news.image}
                        onDone={() => setTimeout(() => {
                            dispatch(studygameActions.finishMinigame())
                        }, 1000)}
                    />
                </div>
            </div>
            <GameButtons />
        </article>
    )
}

export default PuzzleMinigame